import { useState, useEffect } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import ProfileCard from "./ProfileCard";

const ProfileEducationSection = ({ form, setForm, updateProfileSection }) => {
  const [editing, setEditing] = useState(false);

  const education = form.education || {
    school: "",
    degree: "",
    field: "",
    startYear: "",
    endYear: "",
  };

  const isEmpty =
    !education.school &&
    !education.degree &&
    !education.field &&
    !education.startYear &&
    !education.endYear;

  const [localEdu, setLocalEdu] = useState(education);

  useEffect(() => {
    setLocalEdu(education);
  }, [form.education]);

  const saveEducation = async () => {
    const payload = {
      education: {
        school: localEdu.school || "",
        degree: localEdu.degree || "",
        field: localEdu.field || "",
        startYear: localEdu.startYear || "",
        endYear: localEdu.endYear || "",
      },
    };

    await updateProfileSection(payload);
    setForm((prev) => ({
      ...prev,
      education: payload.education,
    }));

    setEditing(false);
  };

  const cancelEditing = () => {
    setLocalEdu(education);
    setEditing(false);
  };

  return (
    <ProfileCard
      title="Education"
      isEditing={editing}
      onEdit={() => setEditing(true)}
      onSave={saveEducation}
      onCancel={cancelEditing}
    >
      {/* empty state shows empty text */}
      {!editing && isEmpty && (
        <div className="experience-empty-state text-center">
          <p>This section is empty</p>
          <span>Add your education details</span>

          <Button
            variant="primary"
            size="sm"
            className="cta-button mt-3"
            onClick={() => setEditing(true)}
          >
            Create
          </Button>
        </div>
      )}

      {/* View mode - has education */}
      {!editing && !isEmpty && (
        <>
          <p>
            <strong>Institution:</strong> {education.school}
          </p>
          <p>
            <strong>Degree:</strong> {education.degree}
          </p>
          <p>
            <strong>Field of Study:</strong> {education.field}
          </p>
          <p>
            <strong>Years:</strong> {education.startYear} –{" "}
            {education.endYear || "Present"}
          </p>
        </>
      )}

      {/* edit mode — show form fields */}
      {editing && (
        <>
          <Form.Control
            className="mb-2"
            placeholder="Institution / School"
            value={localEdu.school}
            onChange={(e) =>
              setLocalEdu((p) => ({ ...p, school: e.target.value }))
            }
          />

          <Form.Control
            className="mb-2"
            placeholder="Degree (e.g., B.Tech, MBA)"
            value={localEdu.degree}
            onChange={(e) =>
              setLocalEdu((p) => ({ ...p, degree: e.target.value }))
            }
          />

          <Form.Control
            className="mb-2"
            placeholder="Field of Study"
            value={localEdu.field}
            onChange={(e) =>
              setLocalEdu((p) => ({ ...p, field: e.target.value }))
            }
          />

          <Row>
            <Col>
              <Form.Control
                className="mb-2"
                placeholder="Start Year"
                type="number"
                value={localEdu.startYear}
                onChange={(e) =>
                  setLocalEdu((p) => ({
                    ...p,
                    startYear: e.target.value,
                  }))
                }
              />
            </Col>
            <Col>
              <Form.Control
                className="mb-2"
                placeholder="End Year"
                type="number"
                value={localEdu.endYear}
                onChange={(e) =>
                  setLocalEdu((p) => ({
                    ...p,
                    endYear: e.target.value,
                  }))
                }
              />
            </Col>
          </Row>
        </>
      )}
    </ProfileCard>
  );
};

export default ProfileEducationSection;
